import React, { useCallback, useEffect, useState } from 'react'
import { H3 } from '../../../../../../../../../Styles/typography'
import { ReviewEl } from './elements'
import SubmissionsStore from '../../stores/SubmissionsStore'
import Textarea from 'react-textarea-autosize'
import Button from '../../../../../../../../../Components/Buttons/Button'
import { useToggle } from '../../../../../../../../../Helpers/CustomHooks/useToggle'

const Review = () => {
  const { activeSubmission, submitReview } = SubmissionsStore.useContainer()
  const [submitting, toggleSubmitting] = useToggle(false)
  const [message, updateMessage] = useState('')

  useEffect(() => {
    updateMessage(activeSubmission?.review?.message || '')
  }, [activeSubmission])

  const submit = useCallback(async () => {
    try {
      toggleSubmitting(true)
      await submitReview(message)
    } finally {
      toggleSubmitting(false)
    }
  }, [message, submitReview, toggleSubmitting])

  return !activeSubmission ? null : (
    <ReviewEl>
      <H3>Review:</H3>

      <Textarea
        width={'100%'}
        name='enrollMessage'
        value={message}
        onChange={(e) => updateMessage(e.target.value)}
        placeholder={'Enter a request message for the teacher'}
      />
      <Button
        onClick={() => submit()}
        name={'Submit Review'}
        type={'primary big'}
        disabled={!message || submitting}
      />
    </ReviewEl>
  )
}

export default Review
